import { jsx as _jsx } from "react/jsx-runtime";
import { useCallback } from 'react';
import Loader from '@jetbrains/ring-ui/components/loader/loader';
import { useDispatch, useSelector } from 'react-redux';
import { Navigate } from 'react-router';
import { AIDisabledIDES } from '@app/pages/profiles/profile-details/profile-ai/ai-disabled-ides/ai-disabled-ides';
import { AIAvailable } from '@app/pages/profiles/profile-details/profile-ai/ai-available/ai-available';
import { useAiConstituent } from '@app/common/queries/ai-enterprise';
import { getProfileConstituents } from '@app/common/store/profiles/selectors';
import { ProfileActions } from '@common/store/profiles/profile-reducer';
import { useServerConfigContext } from '@common/server-config-context/server-config-context';
import { AiDisabledJBA } from './ai-disabled-jba/ai-disabled-jba';
export function ProfileAIPage() {
    const serverConfig = useServerConfigContext();
    const offlineModeEnabled = serverConfig.isOfflineMode();
    const { ai } = useSelector(getProfileConstituents);
    const dispatch = useDispatch();
    const setAiProfileConfig = useCallback((stateChange) => dispatch(ProfileActions.updateAiConstituent(stateChange)), [dispatch]);
    const { data: aiResponse, isLoading: isAiLoading } = useAiConstituent();
    if (offlineModeEnabled) {
        return _jsx(Navigate, { to: "provisioner" });
    }
    if (isAiLoading) {
        return _jsx(Loader, {});
    }
    if ((aiResponse === null || aiResponse === void 0 ? void 0 : aiResponse.status) === 'disabled_by_license') {
        return _jsx(AiDisabledJBA, {});
    }
    if ((aiResponse === null || aiResponse === void 0 ? void 0 : aiResponse.status) === 'disabled') {
        return _jsx(AIDisabledIDES, {});
    }
    if ((aiResponse === null || aiResponse === void 0 ? void 0 : aiResponse.status) === 'enabled') {
        const availableProviders = Object.values(aiResponse.data.provider)
            .map(provider => provider === null || provider === void 0 ? void 0 : provider.id)
            .filter(provider => provider !== 'mellum')
            .filter((provider) => !!provider);
        const topLevelAllowDataCollection = aiResponse.data.allowDataCollection;
        const topLevelAllowLocalProviders = aiResponse.data.allowLocalProviders;
        const defaultProviders = aiResponse.data.defaultProviders || ['jetbrains'];
        return (_jsx(AIAvailable, { enabledForProfile: ai.isEnabled, setAiProfileConfig: setAiProfileConfig, allowDataCollectionEnabled: topLevelAllowDataCollection, allowDataCollection: ai.allowDataCollection, allowLocalProvidersEnabled: topLevelAllowLocalProviders, allowLocalProviders: ai.allowLocalProviders, availableProviders: availableProviders, defaultProviders: defaultProviders }));
    }
    return null;
}
